import { render, staticRenderFns } from "./InputMoneyComponent.vue?vue&type=template&id=4d184960&"
import script from "./InputMoneyComponent.vue?vue&type=script&lang=js&"
export * from "./InputMoneyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports